import { combineReducers } from "redux";
import { reimbursementReducer } from "./reimbursement";
import { submitterReducer } from "./submitter";
import { organizationReducer } from "./organization";

export const unauthenticatedReducer = combineReducers({
  reimbursement: reimbursementReducer,
  submitter: submitterReducer,
  organization: organizationReducer
});



// WEBPACK FOOTER //
// ./frontend/src/actions/unauthenticated/index.js